module.exports = __webpack_public_path__ + "media/images/icons/outlined/tags-f1752454cb4cb48756156f08510c4a20.svg";